const font = {
  default: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica"
};

export default font;



// WEBPACK FOOTER //
// ./src/utils/font.js